/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { ICourse, TUpdateCourseAsAdmin } from '../CoursesSlice';
import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ISection, TUpdateCourseSectionAsAdmin } from '../SectionSlice';

const apiDataProvider = new APIDataProvider();

export const updateCourseAsAdminSavingSlice = createAsyncThunk(
  '/admin/saving/courses/updateOne',
  async ({ _id, ...data }: TUpdateCourseAsAdmin) => {
    const path = `${AdminApiPaths.courses}/${_id}`;
    const response = await apiDataProvider.put<TApiResponse<ICourse>>(
      path,
      data
    );

    return response.data;
  }
);

export const updateCourseSectionAsAdminSavingSlice = createAsyncThunk(
  '/admin/saving/sections/update',
  async ({ _id, ...data }: TUpdateCourseSectionAsAdmin) => {
    const path = `${AdminApiPaths.sections}/${_id}`;
    const response = await apiDataProvider.put<TApiResponse<ISection>>(
      path,
      data
    );

    return response.data;
  }
);

export const updateCourseSectionsSortingAsAdminSavingSlice = createAsyncThunk(
  '/admin/saving/sections/update-sorting-keys',
  async (sections: Array<{ _id: string; sortingKey: number }>) => {
    const path = `${AdminApiPaths.sections}/update-sorting-keys`;
    const response = await apiDataProvider.put<TApiResponse<ISection[]>>(path, {
      sections,
    });

    return response.data;
  }
);
